<template>
  <div
    class="common-spinner-wrapper common-spinner-active"
    :style="inlineStyles"
  >
    <div class="common-loading-spinner"></div>
  </div>
</template>

<script>
export default {
  props: {
    inlineStyles: {
      type: String,
      default() {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.common-spinner-wrapper {
  display: none;

  &.common-spinner-active {
    position: static;
    display: block;
  }
}

.common-loading-spinner {
  border-radius: 50%;
  animation: spin 2s linear infinite;
  width: 16px;
  height: 16px;
  border: 3px solid $black-10;
  border-top: 3px solid $teritiary;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>